import {Component, OnInit} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";

@Component({
    selector: 'mvs-cm-partner-component',
    templateUrl: './cm-partner.component.html',
    standalone: false
})
export class CmPartnerComponent extends ObjectBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
